import { ALL_TIER_VALUE } from "@/lib/post/options"
import { WORDING } from "@/lib/openHouse/wording"
import { cn } from "@/lib/utils"

// Decision 17: the secondary "open to every writer level" choice below the
// levels. It posts today's All Tier Access value; its card shows the service's
// price range from the lowest eligible level to Premium (`price`, the field's
// own line: per 100 words for writing, per sample for a sample). Choosing a
// level in the list above replaces it. On the guest page (ctx.guest) the line is
// only ever the page's (ctx.openLevelsLine): from the server quote, or before it
// the server catalog's level rates.
export function OpenLevelsChoice({ values, ctx, price, setField }) {
  const on = values.tier === ALL_TIER_VALUE
  const line = ctx?.guest ? ctx.openLevelsLine : price?.(values, ctx)

  return (
    <button
      type="button"
      aria-pressed={on}
      onClick={() => setField("tier", ALL_TIER_VALUE)}
      className={cn(
        "flex w-full items-start gap-3 rounded-xl border border-dashed px-4 py-3.5 text-left transition-colors",
        on ? "border-primary bg-[var(--red-soft)]" : "border-line-2 hover:border-ink-3"
      )}
    >
      <span
        aria-hidden="true"
        className={cn(
          "mt-0.5 grid size-4 shrink-0 place-items-center rounded-full border",
          on ? "border-primary" : "border-line-2"
        )}
      >
        {on && <span className="size-2 rounded-full bg-primary" />}
      </span>
      <span className="min-w-0 flex-1">
        <span className="flex flex-wrap items-center gap-2">
          <span className="font-display text-[14px] font-bold text-foreground">{WORDING.openLevels}</span>
          {line && (
            <span className="ml-auto font-display text-[12.5px] font-bold text-muted-foreground">{line}</span>
          )}
        </span>
        <span className="mt-1 block text-[12.5px] leading-relaxed text-muted-foreground">{WORDING.openLevelsDesc}</span>
      </span>
    </button>
  )
}
